import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FilterList from './filterlist/FilterList';
import FilterDefaultsControl from './filterdefaultscontrol/FilterDefaultsControl';
import RefreshControls from '../../common/refreshcontrols/RefreshControls';
import filterDefinitionsPropType from './filterDefinitionsPropType';
import defaultStyles from './FilterHeaderInternal.module.scss';

const FilterHeaderInternal = ({ styles, ...props }) => (
    <header className={ classNames(styles.header, styles.filterHeader) }>
        <div className={ styles.titleWrapper }>
            <div className={ styles.title }>{ props.title }</div>
            { props.disabled ? null : (
                <div className={ styles.filterRemove }>
                    <button className={ styles.button } type="button" onClick={ () => { props.resetFilters(); } }>
                        Reset all filters
                    </button>
                </div>
            ) }
            { props.fixed || props.disabled ? null : (
                <FilterDefaultsControl
                    defaultFilters={ props.defaultFilters }
                    filterDefinitions={ props.filterDefinitions }
                    isOpen={ props.currentlyOpenFilter === 'SET_DEFAULT_FILTERS' }
                    openControl={ () => props.openFilter('SET_DEFAULT_FILTERS') }
                    closeControl={ () => props.openFilter(null) }
                    openDefaultFilter={ props.openDefaultFilter }
                    closeDefaultFilter={ () => props.openDefaultFilter(null) }
                    addDefaultFilter={ props.addDefaultFilter }
                    removeDefaultFilter={ props.removeDefaultFilter }
                    updateDefaultFilter={ props.updateDefaultFilter }
                    currentlyOpenDefaultFilter={ props.currentlyOpenDefaultFilter }
                    getAvailableListValues={ props.getAvailableListValues }
                    showDefaultFilterMenu={ props.showDefaultFilterMenu }
                />
            ) }
            { props.refreshControls ? (
                <RefreshControls
                    onClick={ props.refreshControls.onClick }
                    timeLastUpdated={ props.refreshControls.timeLastUpdated }
                />
            ) : null }
        </div>
        <div className={ styles.filterArea }>
            <FilterList
                fixed={ props.fixed }
                disabled={ props.disabled }
                filters={ props.filters }
                filterErrors={ props.filterErrors }
                filterDefinitions={ props.filterDefinitions }
                currentlyOpenFilter={ props.currentlyOpenFilter }
                openFilter={ props.openFilter }
                updateFilter={ props.updateFilter }
                removeFilter={ props.removeFilter }
                getAvailableListValues={ props.getAvailableListValues }
                addFilter={ props.addFilter }
            />
        </div>
    </header>
);

FilterHeaderInternal.propTypes = {
    title: PropTypes.string,
    fixed: PropTypes.bool,
    disabled: PropTypes.bool,
    filters: PropTypes.arrayOf(PropTypes.shape({})),
    filterErrors: PropTypes.arrayOf(PropTypes.shape({})),
    defaultFilters: PropTypes.arrayOf(PropTypes.shape({})),
    filterDefinitions: filterDefinitionsPropType,
    currentlyOpenFilter: PropTypes.string,
    openFilter: PropTypes.func.isRequired,
    addFilter: PropTypes.func,
    removeFilter: PropTypes.func,
    updateFilter: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    openDefaultFilter: PropTypes.func,
    addDefaultFilter: PropTypes.func,
    removeDefaultFilter: PropTypes.func,
    updateDefaultFilter: PropTypes.func,
    currentlyOpenDefaultFilter: PropTypes.string,
    getAvailableListValues: PropTypes.func.isRequired,
    showDefaultFilterMenu: PropTypes.bool,
    refreshControls: PropTypes.shape({
        onClick: PropTypes.func,
        timeLastUpdated: PropTypes.number
    }),
    styles: PropTypes.objectOf(PropTypes.string)
};

FilterHeaderInternal.defaultProps = {
    title: '',
    fixed: false,
    disabled: false,
    filters: [],
    filterErrors: null,
    defaultFilters: [],
    filterDefinitions: [],
    currentlyOpenFilter: null,
    currentlyOpenDefaultFilter: null,
    showDefaultFilterMenu: true,
    addFilter: noop,
    removeFilter: noop,
    openDefaultFilter: noop,
    addDefaultFilter: noop,
    removeDefaultFilter: noop,
    updateDefaultFilter: noop,
    refreshControls: null,
    styles: defaultStyles
};

export default FilterHeaderInternal;
